import moment from "moment-timezone";

// Presentation only: never replace an IANA ID with an abbreviation or offset.
const englishNames = {
  NST: "Newfoundland Standard Time", NDT: "Newfoundland Daylight Time",
  AST: "Atlantic Standard Time", ADT: "Atlantic Daylight Time",
  EST: "Eastern Standard Time", EDT: "Eastern Daylight Time",
  CST: "Central Standard Time", CDT: "Central Daylight Time",
  MST: "Mountain Standard Time", MDT: "Mountain Daylight Time",
  PST: "Pacific Standard Time", PDT: "Pacific Daylight Time"
};
const neutral = (name, local) => name + " (UTC " + local.format("Z") + ")";

/** Public name at the target instant; province disambiguates shared clock rules. */
export const getPublicTimeZoneLabel = (timeZone, at = new Date(), province) => {
  if (!timeZone || !moment.tz.zone(timeZone)) return "";
  const instant = moment(at);
  if (!instant.isValid()) return "";
  const local = instant.clone().tz(timeZone);
  const day = local.format("YYYY-MM-DD");
  const jurisdiction = String(province || "").trim().toUpperCase();

  if (timeZone === "America/Vancouver" && day >= "2026-09-17")
    return "PCT Pacific Time";
  if (timeZone === "America/Edmonton" && day >= "2026-11-01")
    return jurisdiction && jurisdiction !== "AB"
      ? neutral("MT Mountain Time", local) : "ABT Alberta Time";
  if (["America/Inuvik", "America/Yellowknife"].includes(timeZone) && day >= "2026-11-01")
    return jurisdiction && jurisdiction !== "NT"
      ? neutral("MT Mountain Time", local) : "Northwest Territories Time";
  if (timeZone === "America/Winnipeg" && day >= "2026-10-31")
    return jurisdiction && jurisdiction !== "MB"
      ? neutral("CT Central Time", local) : "MBT Manitoba Standard Time";
  if (timeZone === "America/Rainy_River" && day >= "2026-10-31")
    return neutral("CT Central Time", local);
  if (["America/Whitehorse", "America/Dawson"].includes(timeZone) && day >= "2020-11-01")
    return "YST Yukon Standard Time";

  // Historical and ordinary seasonal labels use authoritative target-date rules.
  const abbreviation = local.zoneAbbr();
  if (timeZone.startsWith("America/") && englishNames[abbreviation])
    return abbreviation + " " + englishNames[abbreviation];

  // Preserve worldwide support for unrelated zones. Canadian cases never
  // depend on browser Intl, which may have stale post-2026 rules.
  try {
    const formatter = new Intl.DateTimeFormat("en", { timeZone, timeZoneName: "long" });
    const part = formatter.formatToParts(local.toDate())
      .find(item => item.type === "timeZoneName");
    if (part && part.value) return part.value;
  } catch (error) { /* Keep the technical IANA abbreviation below. */ }
  return abbreviation;
};
